module.exports = __webpack_public_path__ + "img/1.a72e4a4e.svg";